import * as moment from 'moment';
import * as React from 'react';
import {
    TimeZone,
    TournamentSchedule,
    TournamentScheduleTime,
} from '../../../../generated/protocol';

function isEmpty(str: string | number): boolean {
    return str !== '0' && (!str || '' + str === '');
}

interface Props {
    schedule?: TournamentSchedule,
    timeZones?: TimeZone[],
    calculateSchedule?: (schedule: TournamentSchedule) => Promise<TournamentScheduleTime[]>;
}

interface State {
    index?: number;
    error?: boolean,
    loading?: boolean,
    times?: TournamentScheduleTime[]
}

export class TournamentSchedulePreview extends React.Component<Props, State> {
    timeout: number = undefined;

    constructor(props) {
        super(props);
        this.state = {index: 0};
    }

    isValid() {
        if (!this.props.schedule) {
            return false;
        }
        const schedule: TournamentSchedule = this.props.schedule;
        if (isEmpty(schedule.cronSchedule) || isEmpty(schedule.minutesInAnnounced) ||
            isEmpty(schedule.minutesInRegistering) || isEmpty(schedule.minutesVisibleAfterFinished)) {
            return false;
        }
        return true;
    }

    refresh() {
        if (this.timeout != undefined) {
            clearTimeout(this.timeout);
        }
        this.setState({loading: true});
        this.timeout = setTimeout(() => {
            this.props.calculateSchedule(this.props.schedule).then((res: TournamentScheduleTime[]) => {
                this.setState({times: res, index: 0, loading: false, error: false});
            }).catch(err => {
                this.setState({error: true, times: undefined});
            });
        }, 500);

    }

    componentDidUpdate(prevProps: Props, prevState) {
        if (this.shouldRefresh(prevProps) && this.isValid()) {
            this.refresh();
        }
    }

    componentDidMount() {
        if (this.isValid()) {
            this.refresh();
        }
    }

    shouldRefresh(prevProps: Props) {
        if (prevProps.schedule.cronSchedule !== this.props.schedule.cronSchedule) {
            return true;
        }
        if (prevProps.schedule.minutesInAnnounced !== this.props.schedule.minutesInAnnounced) {
            return true;
        }
        if (prevProps.schedule.notificationMinutes !== this.props.schedule.notificationMinutes) {
            return true;
        }
        if (prevProps.schedule.minutesInRegistering !== this.props.schedule.minutesInRegistering) {
            return true;
        }
        if (prevProps.schedule.startDate !== this.props.schedule.startDate) {
            return true;
        }

        if (prevProps.schedule.endDate !== this.props.schedule.endDate) {
            return true;
        }
        if (prevProps.schedule.timeZoneId !== this.props.schedule.timeZoneId) {
            return true;
        }
        return false;

    }

    next() {
        if (this.state.times.length > this.state.index + 1) {
            this.setState({index: this.state.index + 1});
        }
    }

    prev() {
        if (this.state.index > 0) {
            this.setState({index: this.state.index - 1});
        }
    }

    getCurrentTime(timeZoneId: string, timeZoneName: string) {

        const currentTime: TournamentScheduleTime = this.state.times[this.state.index];

        return (
            <div className='col-sm-12 timezone-row'>
                <div className='col-sm-12'>
                    <h4>{timeZoneName}</h4>
                </div>
                <div className='col-sm-12'>
                    <div className='col-sm-3 time-title'>Announce:</div>
                    <div className='col-sm-9'>{moment(currentTime.announced).tz(timeZoneId).format('LLLL')}</div>
                </div>
                {currentTime.notificationTime &&
                <div className='col-sm-12'>
                    <span className='col-sm-3 time-title'>Notify:</span>
                    <span
                        className='col-sm-9'>{moment(currentTime.notificationTime).tz(timeZoneId).format('LLLL')}</span>
                </div>
                }
                <div className='col-sm-12'>
                    <span className='col-sm-3 time-title'>Register:</span>
                    <span className='col-sm-9'>{moment(currentTime.registering).tz(timeZoneId).format('LLLL')}</span>
                </div>
                <div className='col-sm-12'>
                    <div className='col-sm-3 time-title'>Start:</div>
                    <div className='col-sm-9'>{moment(currentTime.start).tz(timeZoneId).format('LLLL')}</div>
                </div>
            </div>
        );
    }

    getTimeZoneName(id): TimeZone {
        return this.props.timeZones.find((t: TimeZone) => {
            return t.id === id;
        });

    }

    getSchedule() {
        if (!this.state.times || this.state.times.length === 0) {
            return (
                <div className='col-sm-10'>
                    <div className='schedule-box'>
                        <h3>No instances for current configuration</h3>
                    </div>
                </div>
            );
        }

        return (
            <div className='col-sm-10 col-sm-offset-2'>
                <div className='schedule-box' style={{opacity: (this.state.loading ? 0.5 : 1)}}>
                    {this.state.times && this.state.times.length > 0 &&
                    <div className='pull-right'>
                        <a className='btn btn-default' onClick={this.prev.bind(this)}>Prev</a>
                        <a className='btn btn-default' onClick={this.next.bind(this)}>Next</a>
                    </div>
                    }
                    <h3>Showing instance&nbsp;
                        {this.state.index + 1}/{this.state.times.length === 50 ?
                            '50+' : this.state.times.length.toString()}
                    </h3>
                    {this.getCurrentTime('UTC', 'UTC')}
                    {this.getCurrentTime(this.props.schedule.timeZoneId,
                        this.getTimeZoneName(this.props.schedule.timeZoneId).name)}
                    {this.getCurrentTime(moment.tz.guess(), 'Browser Time Zone')}
                </div>

            </div>
        );
    }

    render() {
        if (!this.isValid()) {
            return (
                <div className='row'>
                    <label className='col-sm-2 control-label'>
                        Scheduled Instances
                    </label>
                    <div className='col-sm-10'>
                        <div className='alert alert-warning'>Schedule is invalid</div>
                    </div>
                </div>
            );
        }

        return (
            <div>
                <div className='row'>
                    <label className='col-sm-2 control-label'>
                        Scheduled Instances
                    </label>
                    {this.getSchedule()}
                </div>
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/ui/poker/tournament/TournamentSchedulePreview.tsx